import Immutable from 'immutable';

const Content: {
  dimension: string,
  weight: string,
  resolution: string,
  ruling: string,
  spotColorTolerance: string,
  decimals: number
} = {
  dimension: '',
  weight: '',
  resolution: '',
  ruling: '',
  spotColorTolerance: 'dE',
  decimals: 0
};

class UnitSettings extends Immutable.Record(Content) {
  static fromJS (json: object): any {
    return Immutable.fromJS(json, (key, value) => {
      if (Immutable.isIndexed(value)) {
        return value.toList();
      } else if (key === '') {
        return new UnitSettings(Immutable.Map(value));
      } else {
        return value.toOrderedMap();
      }
    });
  }

  static getDimensionUnits (): Immutable.List<string> {
    return Immutable.List(['mm', 'cm', 'mil', 'inch', 'point']);
  }

  static getWeightUnits (): Immutable.List<string> {
    return Immutable.List(['mg', 'g', 'kg']);
  }

  static getResolutionUnits (): Immutable.List<string> {
    return Immutable.List(['ppi', 'ppmm', 'ppcm']);
  }

  static getRulingUnits (): Immutable.List<string> {
    return Immutable.List(['lpi', 'lpmm', 'lpcm']);
  }

  isImperialDimension (): boolean {
    return ((this.dimension === 'inch') || (this.dimension === 'mil'));
  }

  isMetricDimension (): boolean {
    return ((this.dimension === 'mm') || (this.dimension === 'cm'));
  }
}

export default UnitSettings;
